import Vue from "vue";
import { resolveRequestError } from "@/utils/auth";
import * as ENDPOINTS from "./endpoints";

export default class UserService {
  /**
   *  Fetch dashboard information
   *
   * @async
   * @return {Object} returns an object containing dashboard information
   */
  static async getDashboard() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.DASHBOARD);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   *  Fetch referral information
   *
   * @async
   * @return {Object} returns referral information
   */
  static async getReferralData() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.REFERRAL_DATA);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   *  Fetch referrals
   *
   * @async
   * @return {Object} returns referrals
   */
  static async getReferrals(page = 1) {
    try {
      const { data } = await Vue.http.get(
        `${ENDPOINTS.REFERRALS}?page=${page}`
      );
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   *  Fetch profile
   *
   * @async
   * @return {Object} returns profile
   */
  static async getProfile() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.PROFILE);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   *  Fetch wallet
   *
   * @async
   * @return {Object} returns wallet
   * @todo move this to wallet ?
   */
  static async getWallet() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.WALLET);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   *  Fetch investments
   *
   * @async
   */
  static async getInvestments() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.INVESTMENTS);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   * request OTP
   */
  static async requestOTP(purpose) {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.REQUEST_OTP(purpose));
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   *  Update profile
   *
   * @async
   * @return {Object} returns profile
   * @throws form validation errors
   */
  static async updateProfile(profileData) {
    try {
      const { data } = await Vue.http.put(ENDPOINTS.PROFILE, profileData);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }
  /**
   *  Update profile picture
   *
   * @async
   * @return {Object}
   * @throws form validation errors
   */
  static async changeProfilePicture(photo) {
    try {
      let formData = new FormData();
      formData.append("photo", photo);
      const { data } = await Vue.http.post(ENDPOINTS.CHANGE_PHOTO, formData);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   *  Change email
   *
   * @async
   * @return {Object} returns message
   * @throws form validation errors
   */
  static async changeEmail(email) {
    try {
      const { data } = await Vue.http.put(ENDPOINTS.CHANGE_EMAIL, {
        email
      });
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   *  Change phone number
   *
   * @async
   * @return {Object} returns message
   * @throws form validation errors
   */
  static async changePhoneNo(phonenumber) {
    try {
      const { data } = await Vue.http.put(ENDPOINTS.CHANGE_PHONENUMBER, {
        phonenumber
      });
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async getSlots(page = 1, q = "") {
    try {
      const { data } = await Vue.http.get(
        `${ENDPOINTS.SLOTS}?q=${q}&page=${page}`
      );
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async getNoOfSlots() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.NO_OF_SLOTS);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   * Get user's photo url
   *
   * @return {String}
   */
  static get getPhoto() {
    try {
      return atob(localStorage.getItem("UserPhotoURL"));
    } catch (err) {
      return null;
    }
  }

  /**
   *  Fetch Events Information
   *
   * @async
   * @return {Object} returns an object containing Events
   */
  static async getEvents() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.EVENTS);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }


  /**
   *  Fetch farm requests
   *
   * @async
   */
  static async getFarmRequests() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.FARM_REQUESTS);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }


  /**
   *  Fetch farm subscriptions
   *
   * @async
   */
  static async getFarmSubscriptions() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.FARM_SUBSCRIPTIONS);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }


  static async getFarmSingleSubscriptions(id) {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.INDIVIDUAL_FARMANAGEMENT(id));
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

}
